import {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle
} from "react";
import { useParams } from "react-router-dom";
import {
  listarPerguntas,
  criarPergunta,
  atualizarPergunta
} from "../../services/kpiPerguntasService";

/* =========================
   OPÇÕES PADRÃO
========================= */
const opcoesPadrao = [
  { label: "Excelente", valor: 5 },
  { label: "Bom", valor: 4 },
  { label: "Regular", valor: 3 },
  { label: "Ruim", valor: 1 }
];

const opcoesSimPoucoNao = [
  { label: "Sim, bastante", valor: 5 },
  { label: "Sim, pouco", valor: 3 },
  { label: "Não", valor: 1 }
];

/* =========================
   MODELO INICIAL
========================= */
const perguntaInicial = {
  texto: "",
  tipo: "opcoes",
  peso: 1,
  ordem: 1,
  obrigatoria: true,
  opcoes: [...opcoesPadrao]
};


const KPIQuestions = forwardRef(function KPIQuestions(
  { kpiId: kpiIdProp, modoEmbed = false },
  ref
) {
  const params = useParams();
  const kpiId = kpiIdProp || params.id;

  const [perguntas, setPerguntas] = useState([]);
  const [form, setForm] = useState(perguntaInicial);
  const [loading, setLoading] = useState(false);

  /* =========================
     LOAD
  ========================= */
  useEffect(() => {
    if (!kpiId) return;
    carregar();
  }, [kpiId]);

              async function carregar() {
              const lista = await listarPerguntas(kpiId);

              setPerguntas(lista);

              // define próxima ordem automaticamente
              const proximaOrdem =
                lista.length > 0
                  ? Math.max(...lista.map(p => Number(p.ordem || 0))) + 1
                  : 1;

              setForm(prev => ({
                ...prev,
                ordem: proximaOrdem
              }));
            }


  /* =========================
     HANDLERS
  ========================= */
  function onChange(e) {
  const { name, value, type } = e.target;

  setForm(prev => ({
    ...prev,
    [name]: type === "number" ? Number(value) : value
  }));
}


  function onChangeTipo(e) {
    const tipo = e.target.value;

    if (tipo === "texto") {
      setForm(prev => ({
        ...prev,
        tipo,
        peso: 0,
        opcoes: []
      }));
      return;
    }

    if (tipo === "opcoes_sim_pouco_nao") {
      setForm(prev => ({
        ...prev,
        tipo,
        peso: 0, // pode mudar para 1 se quiser pontuar
        opcoes: opcoesSimPoucoNao
      }));
      return;
    }

    // padrão: opções editáveis
    setForm(prev => ({
      ...prev,
      tipo,
      peso: 1,
      opcoes: opcoesPadrao
    }));
  }

  function onChangeOpcao(index, campo, valor) {
    const novas = [...form.opcoes];
    novas[index][campo] =
      campo === "valor" ? Number(valor) : valor;

    setForm(prev => ({ ...prev, opcoes: novas }));
  }

  /* =========================
     CRUD
  ========================= */
  async function salvarPergunta() {
    if (!kpiId || !form.texto.trim()) return;

    setLoading(true);

    await criarPergunta({
      ...form,
      kpiId,
      peso: Number(form.peso),
      ordem: Number(form.ordem),
      ativa: true
    });

    const perguntaInicial = {
  texto: "",
  tipo: "opcoes",
  peso: 1,
  ordem: 1,
  obrigatoria: true,
  opcoes: [...opcoesPadrao]
};

    await carregar();
    setLoading(false);
  }

  async function toggleAtiva(p) {
    await atualizarPergunta(p.id, { ativa: !p.ativa });
    carregar();
  }

  /* =========================
     EXPÕE PARA O MODAL
  ========================= */
  useImperativeHandle(ref, () => ({
    salvarPergunta
  }));

  /* =========================
     RENDER
  ========================= */
  return (
    <div className={modoEmbed ? "" : "container mt-4"}>
      {!modoEmbed && <h3>Perguntas do KPI</h3>}

      {/* ===== LISTA ===== */}
      <ul className="list-group mb-4">
        {perguntas.length === 0 && (
          <li className="list-group-item text-muted">
            Nenhuma pergunta cadastrada
          </li>
        )}

        {perguntas.map(p => (
          <li key={p.id} className="list-group-item">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <strong>
                  {p.ordem}. {p.texto}
                </strong>
                <div className="text-muted">
                  Tipo: {p.tipo} | Peso: {p.peso}
                </div>
              </div>

              <button
                className={`btn btn-sm ${
                  p.ativa
                    ? "btn-outline-danger"
                    : "btn-outline-success"
                }`}
                onClick={() => toggleAtiva(p)}
              >
                {p.ativa ? "Desativar" : "Ativar"}
              </button>
            </div>
          </li>
        ))}
      </ul>

      {/* ===== NOVA PERGUNTA ===== */}
      <div>
        <h5>Nova Pergunta</h5>

        <input
          className="form-control mb-2"
          placeholder="Texto da pergunta"
          name="texto"
          value={form.texto}
          onChange={onChange}
          required
        />

        <div className="row mb-2">
          <div className="col">
            <label>Tipo da pergunta</label>
            <select
              className="form-control"
              value={form.tipo}
              onChange={onChangeTipo}
            >
              <option value="opcoes">Opções (pontuação)</option>
              <option value="opcoes_sim_pouco_nao">
                Opções (Sim / Pouco / Não)
              </option>
              <option value="texto">Texto (comentário)</option>
            </select>
          </div>

          <div className="col">
            <label>Ordem</label>
            <input
              type="number"
              className="form-control"
              name="ordem"
              value={form.ordem}
              onChange={onChange}
              min="1"
            />
          </div>

          <div className="col">
            <label>Peso</label>

            <input
                  type="number"
                  className="form-control"
                  name="peso"
                  value={form.peso}
                  onChange={onChange}
                  disabled={form.tipo === "texto"}
                  min="0"
                />

          </div>
        </div>

        {/* ===== OPÇÕES EDITÁVEIS (SÓ PARA "opcoes") ===== */}
        {form.tipo === "opcoes" && (
          <>
            <label>Opções</label>
            {form.opcoes.map((op, i) => (
              <div className="d-flex gap-2 mb-2" key={i}>
                <input
                  className="form-control"
                  value={op.label}
                  onChange={e =>
                    onChangeOpcao(i, "label", e.target.value)
                  }
                />
                <input
                  type="number"
                  className="form-control"
                  value={op.valor}
                  onChange={e =>
                    onChangeOpcao(i, "valor", e.target.value)
                  }
                />
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
});

export default KPIQuestions;
